import React, { ReactElement } from 'react';
import { Heading } from '@superops/ui-design-system';
import { withErrorBoundary } from '@nile/components';
import { withRouter } from 'react-router-dom';
import { MONICA_AI_VIEWS } from '@nile/mangifera/src/Constants/workspace';

interface MonicaWorkspaceToolbarProps {
  navMenu: ReactElement;
  toggleNavMenu: () => void;
}

const MonicaWorkspaceToolbar = (props: MonicaWorkspaceToolbarProps) => {
  const { navMenu, toggleNavMenu, match } = props;
  const viewId = match.params?.id;
  const activeViewData = MONICA_AI_VIEWS.find((view) => view?.id === viewId);

  const name = activeViewData?.name;
  return (
    <div className="fx actr p20 h90px divider white-bg">
      <div className="flex actr g20">
        <div onClick={toggleNavMenu}>{navMenu}</div>

        <div>
          <Heading element="h1" weight="Medium">
            {name}
          </Heading>
        </div>
      </div>
    </div>
  );
};

export default withErrorBoundary(withRouter(MonicaWorkspaceToolbar));
